import axios from 'axios';
import queryString from 'query-string';
import { REACT_APP_CONTEXT_PATH } from '../config';
import { RoutePath, TokenParams } from '../constants';
import { hasAppQueryParams } from './param-util';

export function logToRemote(params) {
  const windowOrigin = window.origin;
  const locationOrigin = window.location.origin;
  const path = window.location.pathname;

  if (!params) {
    params = {};
  }

  params.windowOrigin = windowOrigin;
  params.locationOrigin = locationOrigin;
  params.path = path;
  params.hasParams = hasAppQueryParams();
  params[TokenParams.profileId] = sessionStorage.getItem(TokenParams.profileId);

  axios
    .get(`${REACT_APP_CONTEXT_PATH}${RoutePath.log}?${queryString.stringify(params, { sort: false })}`)
    .catch((e) => {
      // don't care about error to log endpoint
    });
}
